import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { IconButton, colors } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ButtonLoading from 'components/ButtonLoading';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: '16px',
    paddingTop: 8,
    fontWeight: 700,
    color: theme.palette.black,
  },
  modalTitleDialog: {
    borderBottom: `1px solid ${colors.grey[200]}`,
  },
  modalTitle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogActions: {
    borderTop: '1px solid',
    borderColor: colors.grey[200],
    padding: '16px 24px',
    marginTop: 15,
  },
  dialogText: {
    lineHeight: '24px',
    letterSpacing: '0.3px',
    maxWidth: 410,
  },
  rejectButton: {
    color: theme.palette.white,
    minWidth: 84,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900],
    },
    '&:disabled': {
      opacity: 0.5,
      color: theme.palette.white,
      borderColor: colors.red[600],
    },
    marginLeft: '20px !important',
  },
  cancelButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900],
    },
  },
}));

const RejectModal = ({
  loading = false,
  reasons,
  opened,
  onCloseModal,
  onSetReason,
  title,
  descr,
  rejectButtonText,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [reasonValue, setReasonValue] = React.useState('');

  const handleChange = (r) => {
    setReasonValue(r);
  };

  const close = () => onCloseModal(false);

  return (
    <>
      {opened ? (
        <Dialog open={opened} onClose={close}>
          {title && (
            <DialogTitle className={classes.modalTitleDialog}>
              <div className={classes.modalTitle}>
                <Typography variant="h4">{title}</Typography>
                <IconButton
                  style={{ padding: '0px' }}
                  aria-label="close reset session modal"
                  onClick={close}>
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
          )}
          {descr && (
            <DialogContent>
              <DialogContentText>
                <Typography variant="subtitle2" className={classes.dialogText}>
                  {descr}
                </Typography>
              </DialogContentText>
            </DialogContent>
          )}
          <DialogContent>
            <FormControl variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                {t('select_reason')}
              </InputLabel>
              <Select
                style={{ minWidth: '410px' }}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={reasonValue.message}
                label={t('select_reason')}
                disabled={loading}>
                {reasons.map((reason) => (
                  <MenuItem
                    onClick={() => handleChange(reason)}
                    value={reason.session_reject_reason_code}
                    key={reason.session_reject_reason_code}>
                    {reason.message}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              color="primary"
              variant="outlined"
              disabled={loading}
              onClick={() => onCloseModal(false)}>
              {t('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onSetReason(reasonValue)}
              // className={classes.rejectButton}
              disabled={!reasonValue || loading}>
              {loading ? (
                <ButtonLoading />
              ) : (
                <>{rejectButtonText ? t(rejectButtonText) : t('Reject Now')}</>
              )}{' '}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default RejectModal;
